<template>
    <div class="resumo-das-parcelas" tabindex="1">
        <button type="button" class="abrir-visualizacao-das-parcelas botao botao_largura-total botao_sem-borda-arredondada botao__com-cursor-de-click botao_gigante" aria-label="Continuar a gerar boleto" v-show="ehMobile && !mostrarResumoDeParcelas" v-on:click="abrir">Continuar</button>
        <div v-show="mostrarResumoDeParcelas" class="resumo-das-parcelas__conteudo" tabindex="1">
            <div class="resumo-das-parcelas__bloco u-margem-inferior-media">
                <div class="grade__linha grade__linha_alinhar-horizontal-centro botao__voltar-lista-de-parcelas" v-on:click="fechar">
                    <button class="botao botao_sem-preenchimento botao_grande botao_icone" aria-label="voltar para listagem de boletos" v-show="ehMobile">
                        <i class="fal fa-chevron-down u-texto-alinhado-ao-centro"></i>
                    </button>
                </div>
                <table class="tabela tabela_com-largura-total">
                    <caption class="titulo titulo_pequeno u-texto-alinhado-a-esquerda u-margem-pequena">Resumo das parcelas selecionadas</caption>
                    <tbody>
                        <tr>
                            <th scope="row">Quantidade de parcelas</th>
                            <td >{{ quantidadeDeParcelas }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Subtotal das parcelas</th>
                            <td>R$ {{ subtotalDasParcelas }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Correção</th>
                            <td>R$ {{ valorDeCorrecao }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Juros de mora</th>
                            <td>R$ {{ valorDeMora }}</td>
                        </tr>
                        <tr>
                            <th scope="row">Multa</th>
                            <td>R$ {{ valorDeMulta }}</td>
                        </tr>
                        <tr v-show="valorDeDesconto > 0">
                            <th scope="row"><strong>Descontos</strong></th>
                            <td> R$ {{ formatarValorMonetarioParaExibicao(valorDeDesconto) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button v-show="valorDeDesconto > 0" :disabled="parcelasSelecionadas.length < 1" @click="emitirBoleto(true)" tabindex="1" type="button" class="botao botao_altura_automatica botao_largura-total botao-acao-primaria u-margem-inferior-media u-padding-media">
                <span class="valor-total-das-parcelas">
                    <i class="fal fa-barcode"></i>
                    R$ {{ formatarValorMonetarioParaExibicao(valorTotalDasParcelasSelecionadas - valorDeDesconto) }}
                </span>
                Emitir boleto com desconto
            </button>
            <button v-show="valorDeDesconto <= 0" :disabled="parcelasSelecionadas.length < 1" @click="emitirBoleto(false)" tabindex="1" type="button" class="botao botao_altura_automatica botao_largura-total botao-vermelho-secundario u-padding-mini">
                <span class="valor-total-das-parcelas">
                    <i class="fal fa-barcode"></i>
                    R$ {{ formatarValorMonetarioParaExibicao(valorTotalDasParcelasSelecionadas) }}
                </span>
                Emitir boleto sem desconto
            </button>
        </div>
    </div>
</template>
<script>
    import http from '../../adapters/http';
    import { formatacaoDeValores } from '../../mixins/formatacaoDeValoresMixin.js'
    import { calculadoraDeDescontosDoMorarLegal } from '../../mixins/calculadoraDeDescontosDoMorarLegal.js'
    import utils from '../../helpers/utilsDeSelecaoDeCobrancas.js'

    export default {
        name: 'resumoDasParcelas',
        data() {
            return {
                mostrarResumoDeParcelas: true,
                larguraDaJanela: window.innerWidth,
                urlDeImpressoraDeBoleto: `/Administracao/ImpressoraDeBoleto/Imprimir`,
                urlDeGerarCobranca: `/Administracao/BoletoOnline/GerarCobranca`,
                urlDeGerarBoletoDeEntrada: `/Administracao/BoletoOnline/GerarBoletoDeEntrada`,
            }
        },
        props: [
            'parcelasSelecionadas',
            'dadosDeNovacao',
            'totalDeParcelasAtrasadas',
            'participaDoMorarLegal'
        ],
        mixins: [
            formatacaoDeValores,
            calculadoraDeDescontosDoMorarLegal
        ],
        methods: {
            ehEntradaDeNovacao(primeiraCobranca) {
                return this.dadosDeNovacao.PossuiNovacao && primeiraCobranca.EhEntrada && this.parcelasSelecionadas.length === 1;
            },
            emitirBoleto(optouPorTerDesconto) {
                var primeiraCobranca = this.parcelasSelecionadas[0];
                var urlDoPostDeBoletos = this.ehEntradaDeNovacao(primeiraCobranca) ? this.urlDeGerarBoletoDeEntrada : this.urlDeGerarCobranca;
                var idDasCobrancas = this.ehEntradaDeNovacao(primeiraCobranca) ?  primeiraCobranca.Id  :  this.parcelasSelecionadas.map(parcela => parcela.Id) ;
                http.post(urlDoPostDeBoletos, {idDasCobrancas, optouPorTerDesconto})
                    .then(res => {
                        if (res.Sucesso) {
                            var cobrancaId = this.ehEntradaDeNovacao(primeiraCobranca) ? primeiraCobranca.Id : res.CobrancaId;
                            location.href = this.urlDeImpressoraDeBoleto + `?cobrancaId=${cobrancaId}&idOrigemDaEmissao=1`;
                        }
                    });
            },
            abrir() {
                this.mostrarResumoDeParcelas = true;
                this.$emit('controlaSobreposicao');
            },
            fechar() {
                this.mostrarResumoDeParcelas = false;
                this.$emit('controlaSobreposicao');
            },
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.larguraDaJanela = window.innerWidth
            })
        },
        computed: {
            quantidadeDeParcelas() {
                return this.parcelasSelecionadas.length;
            },
            subtotalDasParcelas() {
                let total = 0;
                this.parcelasSelecionadas.forEach(parcela => total += parcela.Valor);
                return this.formatarValorMonetarioParaExibicao(total);
            },
            valorDeCorrecao() {
                let total = 0;
                this.parcelasSelecionadas.forEach(parcela => total += parcela.Correcao);
                return this.formatarValorMonetarioParaExibicao(total);
            },
            valorDeMora() {
                let total = 0;
                this.parcelasSelecionadas.forEach(parcela => total += parcela.Mora);
                return this.formatarValorMonetarioParaExibicao(total);
            },
            valorDeMulta() {
                let total = 0;
                this.parcelasSelecionadas.forEach(parcela => total += parcela.Multa);
                return this.formatarValorMonetarioParaExibicao(total);
            },
            valorTotalDasParcelasSelecionadas() {
                let total = 0;
                this.parcelasSelecionadas.forEach(parcela => total += parcela.Total);
                return total;
            },
            valorDeDesconto() {
                if(this.parcelasSelecionadas && this.participaDoMorarLegal) {
                    const parcelasSelecionadasAtrasadas = this.parcelasSelecionadas.filter(p => !utils.cobrancaEstaNaValidade(p))
                    if(parcelasSelecionadasAtrasadas.length === 0 ) return 0
                    const totalDeDescontos = this.calcularDescontoDeParcelas(parcelasSelecionadasAtrasadas, this.totalDeParcelasAtrasadas);
                    return totalDeDescontos;
                } 
                else
                    return 0;
            },
            ehMobile() {
                const ehMobile = this.larguraDaJanela <= 900;
                if (ehMobile)
                    this.mostrarResumoDeParcelas = false;
                else
                    this.mostrarResumoDeParcelas = true;

                return ehMobile;
            }
        }
    }
</script>
